import { useQuery } from "@tanstack/react-query";

import { ICON_STROKE, TrendingUp } from "@/shared/components/icons";
import { TrendChart } from "@/shared/components/TrendChart";
import { fetchOverallSkillHistory } from "@/shared/api";

/** Overall skill-level trajectory (confidence-weighted across mapped skills).
 *  Hidden until there are ≥2 daily points to draw a line. */
export function OverallTrajectory() {
  const history = useQuery({
    queryKey: ["skills-history-overall"],
    queryFn: fetchOverallSkillHistory,
  });

  const points = history.data?.points ?? [];
  if (history.isLoading || points.length < 2) return null;

  return (
    <section className="rounded-xl border border-border bg-surface p-5 space-y-3">
      <div className="flex items-center gap-2">
        <TrendingUp size={16} strokeWidth={ICON_STROKE} className="text-accent" />
        <h2 className="text-sm font-medium tracking-tight">Overall trajectory</h2>
      </div>
      <TrendChart
        points={points.map((p) => ({ date: p.date, value: p.level }))}
        height={120}
        showAxis
        ariaLabel="Overall skill level over time"
      />
    </section>
  );
}
